<!--
  CostMeterComponent — AI cost and status display panel.
  Placed in the sidebar footer. Display-only: no interactive elements.
  aria-live="polite" announces updated values to screen readers after each navigation.
  aria-atomic="true" ensures cost and status are read as a single unit.
-->
<section
  class="cost-meter-panel"
  aria-label="AI cost meter"
  data-testid="cost-meter-widget">

  <dl
    class="cost-meter-content"
    aria-live="polite"
    aria-atomic="true">

    <div class="cost-meter-row">
      <dt class="cost-meter-label">AI Cost</dt>
      <dd class="cost-meter-value" data-testid="cost-meter-cost" #costDisplay>
        {{ costMeterService.formattedCost() }}
      </dd>
    </div>

    <div class="cost-meter-row">
      <dt class="cost-meter-label">Status</dt>
      <dd class="cost-meter-status" data-testid="cost-meter-status">
        {{ costMeterService.currentStatus() }}
      </dd>
    </div>

  </dl>
</section>
